/*@ngInject*/
module.exports = function() {
	return {
		scope: {
			images: '<'
		},
        bindToController: true,
        controllerAs: 'vm',
        controller: function() {
			let vm = this;
			vm.openGalery = function(id) {
				const element = document.getElementById('link_' + id);
				element.click();
			};

			// add focus class on a focused image
			vm.setFocus = function(id) {
				const element = document.getElementById('link_' + id).closest('.detail-car-nav__item');
				element.classList.add('focused-element');
			};

			// remove focus class from unfocused image
			vm.blur = function(id) {
				const element = document.getElementById('link_' + id).closest('.detail-car-nav__item');
				element.classList.remove('focused-element');
			};

			// enable slick elements to click on magnific-popup when entered into
			function handleKeydown(event) {
				if (event.keyCode === 13 && event.target.classList.value.includes('slick-slide')) { // tab key
					let imageIndex = event.target.getAttribute('data-slick-index');
					vm.openGalery(vm.images[imageIndex].id);
				}
			}

			document.addEventListener('keydown', handleKeydown);

		},

		template: require('./object-images.html')
	};
};



/** WEBPACK FOOTER **
 ** ./app/shared/directives/object-images.directive.js
 **/